import React from 'react';
import * as LucideIcons from 'lucide-react';

const MessageStatus = ({ status, onRetry }) => {
  if (status === 'sending') {
    return <LucideIcons.Clock size={16} className="text-gray-400 animate-spin" />;
  }
  if (status === 'failed') {
    return (
      <button onClick={onRetry} className="text-red-500">
        <LucideIcons.AlertCircle size={16} />
      </button>
    );
  }
  if (status === 'sent') {
    return <LucideIcons.Check size={16} className="text-gray-400" />;
  }
  if (status === 'delivered') {
    return <LucideIcons.CheckCheck size={16} className="text-gray-400" />;
  }
  if (status === 'read') {
    return <LucideIcons.CheckCheck size={16} className="text-blue-400" />;
  }
  return null;
};

export default MessageStatus;
